import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ITileInstance } from '../../dashboards/interfaces/tiles/definition-helpers/tile-definition.interface';

@Component({
  standalone: false,
  selector: 'lib-tile-setup-wizard',
  template: '',
})
export class TileSetupWizardComponent<T extends ITileInstance> {
  setupForm: FormGroup;
  tileInstance: T;

  @Output() tempTileDefinitionChanged: EventEmitter<ITileInstance> =
    new EventEmitter<ITileInstance>();

  hookForm() {
    if (!this.setupForm) {
      return;
    }

    this.setupForm.valueChanges.subscribe((val) => {
      this.tempTileDefinitionChanged.emit(this.getChanges());
    });
  }

  getChanges() {
    return {};
  }
}
